// Reads TXT, DOCX or text-based PDF entirely in the browser.
export async function extractText(file, maxMb) {
  if (file.size > maxMb * 1024 * 1024) throw new Error(`File must be ${maxMb} MB or smaller.`);
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  if (ext === "txt") return file.text();
  if (ext === "docx") {
    const mammoth = await import("mammoth/mammoth.browser");
    const res = await mammoth.extractRawText({ arrayBuffer: await file.arrayBuffer() });
    return res.value;
  }
  if (ext === "pdf") {
    const pdfjs = await import("pdfjs-dist/build/pdf.mjs");
    pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
    const pdf = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
    const pages = [];
    for (let i = 1; i <= pdf.numPages; i++) {
      const c = await (await pdf.getPage(i)).getTextContent();
      let line = "", out = [];
      let lastY = null;
      for (const it of c.items) {
        if (!("str" in it)) continue;
        const y = it.transform?.[5];
        if (lastY !== null && Math.abs(y - lastY) > 2) { out.push(line); line = ""; }
        line += (line && !line.endsWith(" ") && it.str && !it.str.startsWith(" ") ? " " : "") + it.str;
        lastY = y;
        if (it.hasEOL) { out.push(line); line = ""; lastY = null; }
      }
      if (line) out.push(line);
      pages.push(out.map((l) => l.replace(/\s+/g, " ").trim()).filter(Boolean).join("\n"));
    }
    const text = pages.join("\n\n");
    if (text.trim().length < 50) throw new Error("This PDF has no readable text (it may be a scan). Please paste the text instead.");
    return text;
  }
  throw new Error("Please upload a PDF, DOCX or TXT file.");
}

export const wordCount = (t) => (t.trim() ? t.trim().split(/\s+/).length : 0);
